/**
 * @flow
 * @relayHash 9aded599f92da2f15e486fca5a9f5f84
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RemoveSolicitationAllocatedDeliverableInput = {|
  solicitationId: string,
  deliverableId: string,
  contractorId: string,
  clientMutationId?: ?string,
|};
export type RemoveAllocatedDeliverableMutationVariables = {|
  input: RemoveSolicitationAllocatedDeliverableInput
|};
export type RemoveAllocatedDeliverableMutationResponse = {|
  +removeSolicitationAllocatedDeliverable: ?{|
    +isUpdated: ?boolean,
    +solicitation: ?{|
      +id: string,
      +numberOfAllocatedDeliverables: ?number,
      +numberOfAllocatedContractedDeliverables: ?number,
    |},
  |}
|};
export type RemoveAllocatedDeliverableMutation = {|
  variables: RemoveAllocatedDeliverableMutationVariables,
  response: RemoveAllocatedDeliverableMutationResponse,
|};
*/


/*
mutation RemoveAllocatedDeliverableMutation(
  $input: RemoveSolicitationAllocatedDeliverableInput!
) {
  removeSolicitationAllocatedDeliverable(input: $input) {
    isUpdated
    solicitation {
      id
      numberOfAllocatedDeliverables
      numberOfAllocatedContractedDeliverables
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemoveSolicitationAllocatedDeliverableInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "removeSolicitationAllocatedDeliverable",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveSolicitationAllocatedDeliverablePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isUpdated",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "solicitation",
        "storageKey": null,
        "args": null,
        "concreteType": "SolicitationNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numberOfAllocatedDeliverables",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numberOfAllocatedContractedDeliverables",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RemoveAllocatedDeliverableMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RemoveAllocatedDeliverableMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RemoveAllocatedDeliverableMutation",
    "id": null,
    "text": "mutation RemoveAllocatedDeliverableMutation(\n  $input: RemoveSolicitationAllocatedDeliverableInput!\n) {\n  removeSolicitationAllocatedDeliverable(input: $input) {\n    isUpdated\n    solicitation {\n      id\n      numberOfAllocatedDeliverables\n      numberOfAllocatedContractedDeliverables\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1dd752e85dad79bae92cef03de1eaac4';
module.exports = node;
